module.exports = __webpack_public_path__ + "img/flejes-packetgrup.00f5b561.jpg";